import React, { useEffect } from "react";
import "./Chart.css";
import CustomPagination from "../../../Common/Common_Component/CustomPagination/CustomPagination";
import { useDispatch, useSelector } from "react-redux";
import { GetAllPeriodHistory } from "../../../../features/games/color_prediction/Slice";
import { transformGameData, transformToHistory } from "../../../../utils/common";

const Chart = ({ mainActiveTab }) => {
  const stats = [
    { label: "Wining Number", values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9] },
    { label: "Missing", values: [2, 26, 20, 7, 11, 1, 3, 10, 6, 0] },
    { label: "Avg Missing", values: [6, 10, 9, 8, 5, 24, 5, 9, 8, 8] },
    { label: "Frequency", values: [2, 26, 20, 7, 11, 1, 3, 10, 6, 0] },
    { label: "Max Consecutive", values: [2, 1, 2, 2, 1, 1, 1, 2, 2, 1] },
  ];

  const history = [
    { period: "202602209100051226", win: 9, color: "teal", type: "B" },
    { period: "202602209100051226", win: 5, color: "pink", type: "B" },
    { period: "202602209100051226", win: 0, color: "pink", type: "S" },
    { period: "202602209100051226", win: 6, color: "red", type: "B" },
    { period: "202602209100051226", win: 8, color: "red", type: "B" },
  ];


  const dispatch = useDispatch();

  const periodHistory = useSelector((state) => state.games.color_prediction);

  const fetch = async (page) => {
    await dispatch(GetAllPeriodHistory({
      page,
      option_id: mainActiveTab?.option_id
    }))
  }


  useEffect(() => {
    fetch(1)
  }, [dispatch, mainActiveTab])


  const handlePageChange = async (page) => {
    fetch(page)
  };

  const newGameData = transformToHistory(periodHistory?.data);

  return (
    <>
      <section className="Chart">
        <div className="unified-chart-container">
          <table className="main-data-table">
            {/* COMMON HEADER */}
            <thead>
              <tr className="header-row">
                <th colSpan="2" className="cell-period">
                  Period
                </th>
                <th className="cell-numbers" colSpan="10">
                  Number
                </th>
              </tr>
            </thead>

            {/* SECTION 1: STATISTICS */}
            {/* <tbody className="stats-section">
              <tr className="stat-info-row">
                <td colSpan="2" className="stat-title">
                  Statistic
                </td>
                <td colSpan="10" className="stat-subtitle">
                  (Last 100 Periods)
                </td>
              </tr>
              {stats.map((item, i) => (
                <tr key={i} className="stat-data-row">
                  <td colSpan="2" className="label-cell">
                    {item.label}
                  </td>
                  {item.values.map((val, idx) => (
                    <td key={idx}>
                      <div className="num-cell">
                        <span
                          className={
                            item.label === "Wining Number"
                              ? "outline-circle"
                              : ""
                          }
                        >
                          {val}
                        </span>
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody> */}

            {/* SECTION 2: HISTORY */}
            <tbody className="history-section">
              {newGameData.map((row, i) => (
                <tr key={i} className="history-data-row">
                  <td className="period-cell">{row.period}</td>
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                    <td key={num}>
                      <div className="num-cell ">
                        <div
                          className={`number-ball ${row.win === num ? `active ${row.color}` : ""
                            }`}
                        >
                          {num}
                        </div>
                      </div>
                    </td>
                  ))}
                  <td>
                    <div className="type-cell">
                      <span
                        className={`type-badge ${row.type === "B" ? "bg-orange" : "bg-blue"
                          }`}
                      >
                        {row.type}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {periodHistory?.data?.length > 0 &&
        <CustomPagination
          currentPage={periodHistory?.period_pagination?.current_page}
          totalPages={periodHistory?.period_pagination?.total_pages}
          handlePageChange={handlePageChange} />
      }
    </>
  );
};

export default Chart;
